import { nextTick, ref, watch } from "vue";

import { getOrCreatePlaceholder, pool } from "./pool";
import { pageTags as pageTagsList } from "./page-tags";
import { motds as motdsList } from "./motds";
import { additionalBanners as additionalBannersList } from "./additionalBanners";
import { motdAppliesToPage } from "./rules/index";
import { remove, type BannerItem, matching, type MotdPosition } from "./models";

type MotdGrouping = { key: MotdPosition; items: BannerItem[] };

(async function () {
    const pageTags = ref(pageTagsList);

    const motds = ref(motdsList);
    const additionalBanners = ref(additionalBannersList);

    const now = ref(new Date());

    function update() {
        const bannersToShow: BannerItem[] = [];
        motds.value
            .filter(motdAppliesToPage)
            .forEach((m) => bannersToShow.push(m));
        additionalBanners.value.forEach((b) => bannersToShow.push(b));

        const motdsToShowByPosition: MotdGrouping[] = bannersToShow.reduce(
            (groups: MotdGrouping[], motd) => {
                let grouping = groups.find((x) => x.key == motd.position);
                if (grouping == null) {
                    grouping = { key: motd.position, items: [] };
                    groups.push(grouping);
                }
                grouping.items.push(motd);
                return groups;
            },
            [] as MotdGrouping[]
        );

        for (const {
            key: position,
            items: groupItems,
        } of motdsToShowByPosition) {
            let placeholder = pool.value.find((x) => x.position == position);
            if (placeholder == null) {
                placeholder = getOrCreatePlaceholder(position);
            }
            const items = Array.from(placeholder.items);
            for (const motd of groupItems) {
                const match = items.find((i) => matching(i, motd));
                if (match == null) {
                    placeholder.items.push(motd);
                } else {
                    items.splice(items.indexOf(match), 1);
                }
            }
            for (const removal of items) {
                remove(removal, placeholder);
            }
        }
    }

    watch(
        () => pool.value,
        () => {
            nextTick(function () {
                update();
            });
        },
        {
            immediate: true,
            deep: true,
        }
    );
    watch(
        () => pageTags.value,
        () => {
            nextTick(function () {
                update();
            });
        },
        {
            immediate: true,
            deep: true,
        }
    );
    watch(
        () => motds.value,
        () => {
            nextTick(function () {
                update();
            });
        },
        {
            immediate: true,
            deep: true,
        }
    );
    watch(
        () => now.value,
        () => {
            nextTick(function () {
                update();
            });
        },
        {
            immediate: true,
        }
    );

    setInterval(() => {
        now.value = new Date();
    }, 1000 * 10);
})();
